"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require("../styles/Container.css");
require("../styles/Icon.css");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
* Nom : IconStatus.js
* Description : Ce fichier contient la définition du composant IconStatus 
*               Ce composant affiche une icone 'un rond avec une couleur déterminée par la valeur fournie'
* Date de création : 21 novembre 2024
*/

/* CSS et assets */

/* Bibliothèques et composants */

/* Hook */
// None

/**
* IconStatus : ce composant affiche une icone 'un rond avec une couleur déterminée par la valeur fournie'
*
* Type : composant 
*
* Parametres : 
*  - color -- texte avec la couleur de l'icône à afficher (vert, jaune, orange ou rouge)
*/function IconStatus(_ref) {
  var color = _ref.color;
  // Render component
  if (color === 'green') {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      className: "status-green status-rounded"
    });
  } else if (color === 'yellow') {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      className: "status-yellow status-rounded"
    });
  } else if (color === 'orange') {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      className: "status-orange status-rounded"
    });
  } else {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      className: "status-red status-rounded"
    });
  }
}

// Les propTypes permettent de sécuriser les données en specifiant le type de donnée attendu pour une prop
IconStatus.propTypes = {
  color: _propTypes["default"].string
};
var _default = exports["default"] = IconStatus;